import { render } from "./RouteView.vue?vue&type=template&id=1a668540"
import script from "./RouteView.vue?vue&type=script&lang=js"
export * from "./RouteView.vue?vue&type=script&lang=js"

import "./RouteView.vue?vue&type=style&index=0&id=1a668540&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__